import { Module } from '../Module';

/**
 * Adds 'tb-hidden' class to an element if the tb-hidden expression evaluates to true.
 *
 * Usage:
 *
 *   span.tb-outline-button(tb-hidden="isHidden()")
 *
 */
Module.instance().directive('tbHidden', <any[]>[
  () => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        scope.$watch(attr['tbHidden'], (hidden: boolean) => {

          // Must coerce to boolean for toggleClass to work correctly
          hidden = !!hidden;
          element.toggleClass('tb-hidden', hidden);
        });
      }
    };
  }
]);
